import { sleep, request } from "utils";

export type EmployeeInfoType = {
  id: String,
  name: String,
  address: String,
  identify_card: String,
  is_quit: Number,
  is_root: Number,
  phone: String,
  identification: String,
  role: String,
  avatar: String,
};

export type EmployeeListType = EmployeeInfoType[];

export type PaginatedEmployeeListType = {
  meta: {
    total: Number,
    count: Number,
    per_page: Number,
    current_page: Number,
    total_pages: Number,
  },
  items: EmployeeInfoType[],
};

const url = "/employee/list";

export async function callGetEmployeeList(
  params: any = {}
): Promise<EmployeeListType> {
  const res = await request.get(url, params);
  return res;
}

export async function callGetPaginatedEmployeeList(
  params: any = {}
): Promise<PaginatedEmployeeListType> {
  const res = await request.get(url, {
    is_paginate: 1,
    ...params,
  });
  return res;
}

export default callGetEmployeeList;
